import { useEffect, useState } from 'react'
import useGetRequest from './useGetRequest'

export default function useGetMontoPago() {
    const [montoUSD, setMontoUSD] = useState(0);
    const monto = useGetRequest(["getMontoPagoAdmision",1]);

    useEffect(() => {
        if( monto && !isNaN(monto) )
            setMontoUSD(monto.toFixed(2));
    }, [monto, setMontoUSD]);

    return montoUSD;
}